import { EXCLUDED_REFERRERS } from '@/constants';

function useInitialReferrer() {
	if (typeof window === 'undefined') return '';
	// Check if sessionStorage has the value
	const storedReferrer = sessionStorage.getItem('initial_referrer');

	if (storedReferrer) {
		return storedReferrer;
	}

	// Check document.referrer
	const currentReferrer = document.referrer;

	// If referrer exists and is valid, then set it and return it
	if (
		currentReferrer &&
		!currentReferrer.startsWith(window.location.origin) &&
		!EXCLUDED_REFERRERS.some((domain) => currentReferrer.includes(domain))
	) {
		sessionStorage.setItem('initial_referrer', currentReferrer);
		return currentReferrer;
	}

	return '';
}

export default useInitialReferrer;
